// extracted by mini-css-extract-plugin
export default {"root":"HZbLn","positionStart":"SDXuq","img":"eogbg"};